/**
 * @fileoverview Custom hook for fetching facilities by organization ID.
 */

import {useQuery} from "react-query";

import {FacilityService} from "../../../services/FacilityService";

type Params = {organizationId: string};

/**
 * Custom hook for fetching facilities filtered by organization ID.
 *
 * @param {Params} params The hook parameters.
 * @param {string} params.organizationId The organization ID to filter facilities by.
 * @returns {Object} React Query result object containing facilities array.
 */
export const useFacilitiesByOrganizationQuery = ({organizationId}: Params) =>
  useQuery(
    ["facilitiesByOrganization", organizationId],
    async () => {
      const {data} = await FacilityService.findByOrganization(organizationId);
      return data;
    },
    {
      enabled: Boolean(organizationId),
    },
  );
